<template>
  <!-- Nomina: la obligacion con esta etiqueta cubre a una lista del personal
       y/o de los vehiculos de la contratista, y en la obligacion se tilda
       quien figura. Al prenderla arranca con Personal. Siempre queda uno de los
       dos tildado: destildar el unico pasa al otro. -->
  <div class="payroll-fields">
    <v-checkbox
      :input-value="isPayroll"
      label="Nómina"
      hide-details
      dense
      :disabled="disabled"
      @change="onPayrollChange"
    />
    <div v-if="isPayroll" class="d-flex payroll-fields__scope">
      <v-checkbox
        :input-value="value.employees"
        label="Personal"
        hide-details
        dense
        class="mr-4"
        :disabled="disabled"
        @change="onScopeChange('employees', $event)"
      />
      <v-checkbox
        :input-value="value.vehicles"
        label="Vehículos"
        hide-details
        dense
        :disabled="disabled"
        @change="onScopeChange('vehicles', $event)"
      />
    </div>
  </div>
</template>

<script>
"use strict";

export default {
  name: "payroll-fields",
  props: {
    // { employees: Boolean, vehicles: Boolean }
    value: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    isPayroll() {
      return !!(this.value.employees || this.value.vehicles);
    }
  },
  methods: {
    onPayrollChange(checked) {
      this.$emit("input", { employees: !!checked, vehicles: false });
    },
    onScopeChange(scope, checked) {
      const other = scope === "employees" ? "vehicles" : "employees";
      const next = Object.assign({}, this.value, { [scope]: !!checked });
      if (!next.employees && !next.vehicles) next[other] = true;
      this.$emit("input", next);
    }
  }
};
</script>

<style lang="scss">
.payroll-fields__scope {
  padding-left: 32px;
}
</style>
